"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseConfSam = void 0;
exports.configHandler = configHandler;
const criteria_1 = require("./criteria");
const mesure_1 = require("./mesure");
function configHandler(listOfConfigParam, criteriaDict, mesureDict) {
    let listOfConfig = [];
    for (let configParam of listOfConfigParam) {
        let newCrit = new criteriaDict[configParam.criteria](configParam.id, mesureDict[configParam.mesure], configParam.param);
        listOfConfig.push(newCrit);
    }
    return listOfConfig;
}
let baseConfListSam = [{
        'criteria': 'comparaison',
        'id': 'comparaison',
        'mesure': 'mmp',
        'param': { 'nb_step': 4, 'threshold': 0.75, 'stepToCompute': 4, 'tolerance': 0.1 }
    },
    {
        'criteria': 'flag',
        'id': 'flag',
        'mesure': 'score',
        'param': { 'nb_step': 4, 'threshold': 0.4, 'stepToCompute': 4 }
    }];
exports.baseConfSam = configHandler(baseConfListSam, criteria_1.criteriaDict, mesure_1.mesureDict);
